// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"be24aba9","26":"8602eaa1","47":"8964be02","383":"96262c51","404":"fa33b35f","427":"06f17e6d","514":"5f782fab","522":"42988f19","551":"722280af","823":"8d369fdf","855":"d2e0cd5f"}[chunkId] + ".chunk.js";
};